import { render, staticRenderFns } from "./UiHeader.vue?vue&type=template&id=25a8790c"
import script from "./UiHeader.vue?vue&type=script&lang=js"
export * from "./UiHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports